import { Box, Grid, Typography } from "@material-ui/core";
import { blue, green, orange } from "@material-ui/core/colors";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { Database, LifeBuoy } from "react-feather";
import { useOrderInfoFetch } from "src/hooks/profit/useOrderInfoFetch";
import { useOrderLastMonthFetch } from "src/hooks/profit/useOrderLastMonthFetch";
import { useSaleInfoFetch } from "src/hooks/profit/useSaleInfoFetch";
import { useSaleLastMonthFetch } from "src/hooks/profit/useSaleLastMonthFetch";
import ProfitItem from "./ProfitItem";
const ProfitOverview = () => {
  const {
    state: order,
    loading: orderLoading,
    error: orderError,
  } = useOrderInfoFetch();
  const {
    state: sale,
    loading: saleLoading,
    error: saleError,
  } = useSaleInfoFetch();
  const {
    state: orderLast,
    loading: orderLastLoading,
    error: orderLastError,
  } = useOrderLastMonthFetch();
  const {
    state: saleLast,
    loading: saleLastLoading,
    error: saleLastError,
  } = useSaleLastMonthFetch();

  const orderRevenuePercent =
    Math.floor(
      ((order.revenue - orderLast.revenue) / orderLast.revenue - 1) * 100
    ) || 0;
  const saleRevenuePercent =
    Math.floor(
      ((sale.revenue - saleLast.revenue) / saleLast.revenue - 1) * 100
    ) || 0;
  const orderProfitPercent =
    Math.floor(
      ((order.profit - orderLast.profit) / orderLast.profit - 1) * 100
    ) || 0;
  const saleProfitPercent =
    Math.floor(((sale.profit - saleLast.profit) / saleLast.profit - 1) * 100) ||
    0;

  const totalRevenuePercent =
    Math.floor(
      ((order.revenue + sale.revenue - orderLast.revenue - saleLast.revenue) /
        (orderLast.revenue + saleLast.revenue) -
        1) *
        100
    ) || 0;

  const totalProfitPercent =
    Math.floor(
      ((order.profit + sale.profit - orderLast.profit - saleLast.profit) /
        (orderLast.profit + saleLast.profit) -
        1) *
        100
    ) || 0;

  const data = [
    {
      name: "Total Order Revenue",
      amount: Math.round(order.revenue * 100) / 100,
      percent: orderRevenuePercent === Infinity ? 0 : orderRevenuePercent,
      color: blue[600],
      icon: <AttachMoneyIcon />,
    },
    {
      name: "Total Order Profit",
      amount: Math.round(order.profit * 100) / 100,
      percent: orderProfitPercent === Infinity ? 0 : orderProfitPercent,
      color: blue[600],
      icon: <AttachMoneyIcon />,
    },
    {
      name: "Total In-store Revenue",
      amount: Math.round(sale.revenue * 100) / 100,
      percent: saleRevenuePercent === Infinity ? 0 : saleRevenuePercent,
      color: green[600],
      icon: <LifeBuoy />,
    },
    {
      name: "Total In-store Profit",
      amount: Math.round(sale.profit * 100) / 100,
      percent: saleProfitPercent === Infinity ? 0 : saleProfitPercent,
      color: green[600],
      icon: <LifeBuoy />,
    },
    {
      name: "Total Revenue",
      amount: Math.round((order.revenue + sale.revenue) * 100) / 100,
      percent: totalRevenuePercent === Infinity ? 0 : totalRevenuePercent,
      color: orange[600],
      icon: <Database />,
    },
    {
      name: "Total Profit",
      amount: Math.round((order.profit + sale.profit) * 100) / 100,
      percent: totalProfitPercent === Infinity ? 0 : totalProfitPercent,
      color: orange[600],
      icon: <Database />,
    },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography color="textPrimary" gutterBottom variant="h3">
        Profit Summary
      </Typography>

      <Grid container spacing={3}>
        {data.map((item, index) => (
          <ProfitItem key={index} item={item} />
        ))}
      </Grid>
    </Box>
  );
};

export default ProfitOverview;
